import React, { useState } from 'react'
import { Spinner } from '@shopify/polaris'
import i18n from '../translations/i18n'

const Loader = () => {
  const { t } = i18n

  return (
    <div
      style={{
        height: 300,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        position: 'relative',
      }}
    >
      <Spinner
        accessibilityLabel={t('fetching-products')}
        size="large"
        color="teal"
        style={{ height: 100 }}
      />
    </div>
  )
}

export default Loader
